import { render } from "./GestionDicc.vue?vue&type=template&id=148c7c7c&scoped=true"
import script from "./GestionDicc.vue?vue&type=script&lang=js"
export * from "./GestionDicc.vue?vue&type=script&lang=js"

import "./GestionDicc.vue?vue&type=style&index=0&id=148c7c7c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-148c7c7c"

export default script